<div class="display-flex flex-align-center full-height">
  <div class="phases-container full-width relative">
    <div *ngFor="let phase of phases" [ngStyle]="{ width: phase.value + '%' }" [class]="phase.class"></div>
  </div>
  <div class="phases-percentages">
      <div *ngFor="let phase of phases" [matTooltip]="'reports.phases.'+phase.name | translate">{{ phase.value }} %</div>
  </div>
</div>
